import { getStripePlanId } from '@/lib/getStripePlanId'
import { MembershipPlan } from '@/types/membershipPlan'
import { MembershipTerm } from '@/types/membershipTerm'
import { StripePlanId } from '@/types/StripePlanId'
import { User } from '@/types/user'
import { StripeError } from '@stripe/stripe-js'
import { fetchPostJSON } from './fetchPostJSON'
import getStripe from './getStripe'

type Params = {
  plan: MembershipPlan
  term: MembershipTerm
  user: User
}

const redirectToCheckout = async (sessionId: string) => {
  const stripe = await getStripe()
  return await stripe!.redirectToCheckout({ sessionId })
}

export const getStripeSession = async ({
  stripePlanID,
  user,
}: {
  stripePlanID: StripePlanId
  user: User
}) => {
  const data = {
    plan: stripePlanID,
    email: user?.email,
    stripe_id: user?.stripe_id,
  }

  return await fetchPostJSON(
    `${process.env.NEXT_PUBLIC_URL}/api/checkout_sessions`,
    data
  )
}

export const createStripeCheckout = async ({
  plan,
  term,
  user,
}: Params): Promise<{ error: StripeError } | undefined> => {
  const currency = user?.country === 'CA' ? 'CAD' : 'USD'

  // Get plan id
  const stripePlanID = getStripePlanId({ plan, term, currency })

  if (!stripePlanID) {
    throw new Error(
      `No stripe subscription id found for ${plan} ${term} ${user?.country}`
    )
  }

  // Get Stripe session
  const { id: stripeSessionId } = await getStripeSession({ stripePlanID, user })

  if (!stripeSessionId)
    throw new Error(
      `Could not find stripe session for ${stripePlanID} - ${user?.uuid}`
    )

  // Redirect to checkout
  const redirect = redirectToCheckout(stripeSessionId)
  if (redirect) {
    return { ...redirect }
  }
}
